<p-table #dt
         dialogTableAccessibility
         [ariaLabel]="('iaa.choose' | translate) + fieldNameByLang"
         [(selection)]="selectedItem"
         [metaKeySelection]="true"
         [columns]="[{ field: fieldName, header: 'Name' }]"
         [dataKey]="key"
         [scrollable]="true"
         [selectionMode]="'single'"
         [styleClass]="'hover-text'"
         [value]="values"
         [virtualScrollItemSize]="46"
         [virtualScroll]="true"
         scrollHeight="300"
         *ngIf="isVisible">
  <ng-template pTemplate="caption">
    <div class="flex align-items-center justify-content-between w-full">
      <span [ngClass]="{'p-input-icon-right': currentLanguage === 'en', 'p-input-icon-left': currentLanguage === 'he'}">
        <i class="pi pi-search search-icon"></i>
        <input 
               (input)="checkContains(dt, $event)"
               class="w-full no-clear-button"
               pInputText 
               [placeholder]="'iaa.aria.search' | translate"
               type="text"
               role="combobox"
               [attr.aria-label]="fieldNameByLang"
               aria-autocomplete="list"
        />
      </span>      
    </div>
  </ng-template>

  <ng-template let-rowData pTemplate="body">
    <tr [pSelectableRow]="rowData" (click)="toggleTag(rowData)" (keydown.space)="toggleTag(rowData)" class="row" role="option" [attr.aria-selected]="rowData == selectedItem">
      <div><bdi>{{ rowData[fieldName] | translateLang | async }}</bdi></div>
        <div class="item">
          <div *ngIf="!rowData.selected" class="hover-text">
            <i class="pi pi-plus add-remove-icon"></i> {{'iaa.general.add' | translate }}
          </div>
          <div *ngIf="rowData.selected" class="hover-text">
            <i class="pi pi-times add-remove-icon"></i> {{'iaa.general.remove' | translate }}
          </div>
        </div>
    </tr>

  </ng-template>
</p-table>